import React, { Component } from 'react';
import FileUploader from "./ImagenTexto/FileUploader";
import FileUploaderUpdate from "./ImagenTexto/FileUploaderUpdate";
import { MDBIcon, MDBInput } from 'mdbreact';
import reactCSS from 'reactcss';
import { SketchPicker } from 'react-color';
import { CargueImagenes, Seguros_ } from '../../../services/WebAPI_Utrahuilca';
import Swal from 'sweetalert2';

const validate = values => {
    const errors = {}
    if (!values.nombseguro) {
        errors.nombseguro = 'campo obligatorio'
    }
    if (!values.txtseguro1) {
        errors.txtseguro1 = 'campo obligatorio'
    }
    if (!values.txtseguro2) {
        errors.txtseguro2 = 'campo obligatorio'
    }
    if (values.posiciontexto === 'DEFAULT') {
        errors.posiciontexto = 'campo obligatorio'
    }
    return errors;
};

class ImagenTexto extends Component {
    uploader = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            estadoNuevo: false,
            errors: {},
            estadoCambioImg1: true,
            infoSeguros: [],
            nombseguro: '',
            txtseguro1: '',
            txtseguro2: '',
            editnombseguro: '',
            edittxtseguro1: '',
            edittxtseguro2: '',
            posiciontexto: 'DEFAULT',
            editposiciontexto: 0,
            estadoImagen: false,
            displayColorPicker: false,
            rutafondoseg: '',
            color: '#ffffff',
            estadoSinInfo: false,
        };
    }

    async componentDidMount() {
        this.cargarInformacion();
    }

    cargarInformacion = () => {
        const data = {
            tran: 4,
            idvtaseguro: 0,
            nombseguro: 'NA',
            rutafondoseg: 'NA',
            txtseguro1: 'NA',
            txtseguro2: 'NA',
            txtslider3: 'NA',
            posiciontexto: 0,
            colortexto: 'NA',
            estado: 0,
            usucrea: 'NA'
        }
        Seguros_(data).then(response => {
            try {
                if (response.data.length > 0) {
                    if (!response.data[0].message) {
                        this.setState({
                            idSeleccionado: response.data[0].idvtaseguro
                        })
                        setTimeout(() => {
                            this.setState({
                                infoSeguros: response.data,
                                editnombseguro: response.data[0].nombseguro,
                                rutafondoseg: response.data[0].rutafondoseg,
                                edittxtseguro1: response.data[0].txtseguro1,
                                edittxtseguro2: response.data[0].txtseguro2,
                                edittxtslider3: response.data[0].txtslider3,
                                editposiciontexto: response.data[0].posiciontexto,
                                color: response.data[0].colortexto,
                                estado: response.data[0].estado,
                                estadoSinInfo: true,
                                estadoImagen: true,
                            })
                            document.getElementById('' + response.data[0].idvtaseguro + '').style.background = "#f47216";
                            document.getElementById('' + response.data[0].idvtaseguro + '').style.color = "#fff";
                            document.getElementById('' + response.data[0].idvtaseguro + '').style.fontWeight = "bold";
                        }, 120);
                    } else {
                        this.setState({
                            estadoSinResultados: false,
                            estadoNuevo: true,
                            estadoCambioImg1: true,
                            estadoSinInfo: false
                        })
                    }
                } else { }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    text: 'Ocurrio un error al consumir el servicio!'
                })
            }
        });
    }

    textInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    cambioImagen1 = (name, file) => {
        this.setState({
            estadoCambioImg1: true
        });
    }

    cambioImagen = (name, file) => {
        this.setState({
            estadoCambioImg: true
        });
    }

    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker })
    };

    handleClose = () => {
        this.setState({ displayColorPicker: false })
    };

    handleChange = (color) => {
        this.setState({ color: color.hex })
    };

    cargarImagen = () => {
        var formData = new FormData();
        if (undefined === this.uploader.current) return;
        
        formData.append("file", this.uploader.current.getFileObject());
        formData.append("rutaImagen", '/Seguros/ImagenTexto/' + this.uploader.current.getFileName());
        CargueImagenes(formData).then(response => {
            if (response) {
                this.cargarInformacion();
            }
        });
    }

    insertarDatos = () => {
        const { errors, ...sinErrors } = this.state;
        const result = validate(sinErrors);
        this.setState({ errors: result });
        if (!Object.keys(result).length) {
            // formulario validado
            const data = {
                tran: 1,
                idvtaseguro: 0,
                nombseguro: this.state.nombseguro,
                rutafondoseg: '/Seguros/ImagenTexto/' + this.uploader.current.getFileName(),
                txtseguro1: this.state.txtseguro1,
                txtseguro2: this.state.txtseguro2,
                posiciontexto: parseInt(this.state.posiciontexto),
                colortexto: this.state.color,
                estado: 1,
                usucrea: sessionStorage.getItem('idusuario')
            }
            Seguros_(data).then(response => {
                if (response.data.length > 0) {
                    if (response.data[0].message === "000000") {
                        this.cargarImagen();
                        Swal.fire({
                            icon: 'success',
                            title: 'Se agrego correctamente.'
                        })
                        this.setState({
                            estadoNuevo: false,
                            nombseguro: '',
                            txtseguro1: '',
                            txtseguro2: '',
                            posiciontexto: 'DEFAULT',
                            estadoImagen: false,
                            displayColorPicker: false,
                            rutafondoImg: '',
                            color: '#ffffff',
                        })
                        this.cargarInformacion();
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error al insertar.'
                        })
                    }
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ocurrio un error!'
                    })
                }
            });
        }
    }

    busquedaId = (id) => {
        document.getElementById('' + this.state.idSeleccionado + '').style.background = "#fff";
        document.getElementById('' + this.state.idSeleccionado + '').style.color = "#000";
        document.getElementById('' + this.state.idSeleccionado + '').style.fontWeight = "normal";
        document.getElementById('' + id + '').style.background = "#f47216";
        document.getElementById('' + id + '').style.color = "#fff";
        document.getElementById('' + id + '').style.fontWeight = "bold";
        this.setState({
            estadoCambioImg: false,
            est: !this.state.est,
            idSeleccionado: id
        })
        const data = {
            tran: 5,
            idvtaseguro: id,
            nombseguro: 'NA',
            rutafondoseg: 'NA',
            txtseguro1: 'NA',
            txtseguro2: 'NA',
            txtslider3: 'NA',
            posiciontexto: 0,
            colortexto: 'NA',
            estado: this.state.estado,
            usucrea: sessionStorage.getItem('idusuario')
        }
        Seguros_(data).then(response => {
            if (response.data.length > 0) {
                this.setState({
                    editnombseguro: response.data[0].nombseguro,
                    rutafondoseg: response.data[0].rutafondoseg,
                    edittxtseguro1: response.data[0].txtseguro1,
                    edittxtseguro2: response.data[0].txtseguro2,
                    edittxtslider3: response.data[0].txtslider3,
                    editposiciontexto: response.data[0].posiciontexto,
                    color: response.data[0].colortexto,
                    estado: response.data[0].estado,
                })
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'No hay información'
                })
            }
        });
    }

    activar = (id) => {
        const data = {
            tran: 6,
            idvtaseguro: id,
            nombseguro: 'NA',
            rutafondoseg: 'NA',
            txtseguro1: 'NA',
            txtseguro2: 'NA',
            txtslider3: 'NA',
            posiciontexto: 0,
            colortexto: 'NA',
            estado: 1,
            usucrea: sessionStorage.getItem('idusuario')
        }
        Seguros_(data).then(response => {
            if (response) {
                this.setState({
                    estadoS: false
                })
                Swal.fire({
                    icon: 'success',
                    title: 'Se activo satisfactoriamente'
                });
                document.getElementById('' + this.state.idSeleccionado + '').style.background = "#fff";
                document.getElementById('' + this.state.idSeleccionado + '').style.color = "#000";
                document.getElementById('' + this.state.idSeleccionado + '').style.fontWeight = "normal";
                this.cargarInformacion();
            }
        });
    }

    actualizarDatos = (id) => {
        var ruta = '';
        var capNombre = this.uploader.current.getFileName();
        if (capNombre === undefined || capNombre === null) {
            ruta = this.state.rutafondoseg;
        } else {
            ruta = '/Seguros/ImagenTexto/' + this.uploader.current.getFileName();
        }
        const data = {
            tran: 1,
            idvtaseguro: id,
            nombseguro: this.state.editnombseguro,
            rutafondoseg: ruta,
            txtseguro1: this.state.edittxtseguro1,
            txtseguro2: this.state.edittxtseguro2,
            posiciontexto: parseInt(this.state.editposiciontexto),
            colortexto: this.state.color,
            estado: 1,
            usucrea: sessionStorage.getItem('idusuario')
        }
        Seguros_(data).then(response => {
            if (response.data.length > 0) {
                if (response.data[0].message === "000000") {
                    this.cargarImagen();
                    this.setState({
                        estadoCambio: false,
                        estadoEditar: false,
                        editposiciontexto: ''
                    })
                    Swal.fire({
                        icon: 'success',
                        title: 'Se actualizo satisfactoriamente'
                    })
                    document.getElementById('' + this.state.idSeleccionado + '').style.background = "#fff";
                    document.getElementById('' + this.state.idSeleccionado + '').style.color = "#000";
                    document.getElementById('' + this.state.idSeleccionado + '').style.fontWeight = "normal";
                    this.cargarInformacion();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ocurrio un error al actualizar'
                    })
                }
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Ocurrio un error!'
                })
            }
        });
    }

    handleNew = () => {
        this.setState({
            estadoNuevo: !this.state.estadoNuevo,
            errors: {},
        })
        if (this.state.estadoNuevo) {
            this.setState({
                errors: {},
            })
            this.cargarInformacion();
        }
    }

    render() {
        const { estadoNuevo, infoSeguros, nombseguro, estadoCambioImg1, estadoCambioImg, errors, estadoSinInfo, txtseguro1, txtseguro2, posiciontexto, estadoImagen, rutafondoseg } = this.state;
        const styles = reactCSS({
            'default': {
                color: {
                    width: '36px',
                    height: '14px',
                    borderRadius: '2px',
                    background: this.state.color,
                    // background: `rgba(${this.state.color.r}, ${this.state.color.g}, ${this.state.color.b}, ${this.state.color.a})`,
                },
                swatch: {
                    padding: '5px',
                    background: '#fff',
                    borderRadius: '1px',
                    boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                    display: 'inline-block',
                    cursor: 'pointer',
                },
                popover: {
                    position: 'absolute',
                    zIndex: '2',
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
            },
        });
        return (
            <React.Fragment>
                <p>Imagen - Texto Seguros</p>
                <hr />
                {estadoSinInfo ? (
                    <React.Fragment>
                        <div className="plus_add_agencia align-items-center d-flex" onClick={() => { this.handleNew() }}>
                            {estadoNuevo ? <p>Cancelar &nbsp;<MDBIcon icon="times" size="lg" /></p> : <p>Agregar Nuevo &nbsp;<MDBIcon icon="plus-circle" size="lg" /></p>}
                        </div>
                    </React.Fragment>
                ) : (
                    <React.Fragment></React.Fragment>
                )}
                {estadoNuevo ? (
                    <React.Fragment>
                        <div className="justify-content-center d-flex">
                            <div className="text-center">
                                <FileUploader ref={this.uploader} estadoImg={estadoCambioImg1} FCambiar={this.cambioImagen1} />
                            </div>
                        </div>
                        <div className="container mt-5 pt-5 pb-5">
                            <div className="row">
                                <div className="col-md-4">
                                    <MDBInput label="Nombre" type="text" name="nombseguro" value={nombseguro} onChange={this.textInput} />
                                    {errors.nombseguro && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '50px' }}>{errors.nombseguro}</strong>}
                                </div>
                                <div className="col-md-4">
                                    <MDBInput label="Texto 1" type="text" name="txtseguro1" value={txtseguro1} onChange={this.textInput} />
                                    {errors.txtseguro1 && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '50px' }}>{errors.txtseguro1}</strong>}
                                </div>
                                <div className="col-md-4">
                                    <MDBInput label="Texto 2" type="text" name="txtseguro2" value={txtseguro2} onChange={this.textInput} />
                                    {errors.txtseguro2 && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '50px' }}>{errors.txtseguro2}</strong>}
                                </div>
                                <div className="col-md-6 mt-3">
                                    <label>Posición Texto</label>
                                    <select name="posiciontexto" className="form-control" value={posiciontexto} onChange={this.textInput}>
                                        <option value="DEFAULT" disabled>Seleccione..</option>
                                        <option value="1">Izquierda</option>
                                        <option value="0">Derecha</option>
                                    </select>
                                    {errors.posiciontexto && <strong className="text-danger" style={{ fontSize: '13px' }}>{errors.posiciontexto}</strong>}
                                </div>
                                <div className="col-md-6 mt-3">
                                    <p>Color Texto</p>
                                    <div style={styles.swatch} onClick={this.handleClick}>
                                        <div style={styles.color} />
                                    </div>
                                    {this.state.displayColorPicker ? <div style={styles.popover}>
                                        <div style={styles.cover} onClick={this.handleClose} />
                                        <SketchPicker color={this.state.color} onChange={this.handleChange} />
                                    </div> : null}
                                </div>
                            </div>
                        </div>
                        <div className="pt-2 mt-5 modal-footer w-100">
                            <button type="button" className="btn btn-primary px-5" onClick={this.insertarDatos}>Guardar nuevo &nbsp; <MDBIcon icon="save" /></button>
                        </div>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <div className="listado_banner pt-5">
                            <p>Seleccionar banner</p>
                            <ul>
                                {infoSeguros.map((e, i) => {
                                    let view;
                                    if (e.estado === 1) {
                                        view = <MDBIcon icon="eye" size="lg" style={{ color: 'black', position: 'absolute', right: '-38px', marginTop: '5px' }} />
                                    } else {
                                        view = <MDBIcon onClick={() => { this.activar(e.idvtaseguro) }} icon="eye-slash" size="lg" style={{ color: 'black', position: 'absolute', right: '-38px', marginTop: '5px' }} />
                                    }
                                    return [
                                        <li key={i} id={e.idvtaseguro} onClick={() => { this.busquedaId(e.idvtaseguro) }}>{e.nombseguro} {view}</li>
                                    ]
                                })}
                            </ul>
                        </div>
                        <div className="justify-content-center d-flex">
                            <div className="text-center">
                                {estadoImagen ? (
                                    <FileUploaderUpdate ref={this.uploader} ruta={rutafondoseg} estadoImg={estadoCambioImg} FCambiar={this.cambioImagen} />
                                ) : (
                                    <React.Fragment></React.Fragment>
                                )}
                            </div>
                        </div>
                        <div className="container mt-5 pt-5 pb-5">
                            <div className="row">
                                <div className="col-md-4">
                                    <MDBInput label="Nombre" type="text" name="editnombseguro" value={this.state.editnombseguro} onChange={this.textInput} />
                                </div>
                                <div className="col-md-4">
                                    <MDBInput label="Texto 1" type="text" name="edittxtseguro1" value={this.state.edittxtseguro1} onChange={this.textInput} />
                                </div>
                                <div className="col-md-4">
                                    <MDBInput label="Texto 2" type="text" name="edittxtseguro2" value={this.state.edittxtseguro2} onChange={this.textInput} />
                                </div>
                                <div className="col-md-6 mt-3">
                                    <label>Posición Texto</label>
                                    <select name="editposiciontexto" className="form-control" value={this.state.editposiciontexto} onChange={this.textInput}>
                                        <option value="DEFAULT" disabled>Seleccione..</option>
                                        <option value="1">Izquierda</option>
                                        <option value="0">Derecha</option>
                                    </select>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <p>Color Texto</p>
                                    <div style={styles.swatch} onClick={this.handleClick}>
                                        <div style={styles.color} />
                                    </div>
                                    {this.state.displayColorPicker ? <div style={styles.popover}>
                                        <div style={styles.cover} onClick={this.handleClose} />
                                        <SketchPicker color={this.state.color} onChange={this.handleChange} />
                                    </div> : null}
                                </div>
                            </div>
                        </div>
                        <div className="pt-2 mt-5 modal-footer w-100">
                            <button type="button" className="btn btn-success px-5" onClick={() => { this.actualizarDatos(this.state.idSeleccionado) }}>Guardar cambios &nbsp; <MDBIcon icon="save" /></button>
                        </div>
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    }
}

export default ImagenTexto;